import { useEffect, useSyncExternalStore } from 'react';
import { getAssetPrecache, type AssetPrecacheState } from '@sorrem-client/ui/assets/asset-precache';

/**
 * The page's asset precaching (#285), started by the first screen that
 * asks for it (Character Home, entering Sorrem) and shared by every screen
 * after: the core tier while the player waits to enter, then the run tier
 * in the background.
 */
export function useAssetPrecache(): AssetPrecacheState {
    const precache = getAssetPrecache();
    useEffect(() => {
        precache.start();
    }, [precache]);
    return useSyncExternalStore(precache.subscribe, precache.getState);
}

/** The player-facing line for a tier being cached: "Caching 42 of 310 assets". */
export function formatAssetPrecache(state: AssetPrecacheState): string {
    return `Caching ${state.done} of ${state.total} assets`;
}
